import React, { PropTypes } from 'react';
import { Dialog, FontIcon, FlatButton } from 'material-ui';

const FileError = props => {
  const {
    showDialog,
    title,
    confirmButtonFunc,
    topText,
    problemFiles,
    subtext,
  } = props;

  return (
    <Dialog
      title={title}
      actions={
        <FlatButton
          label="OK"
          secondary
          onTouchTap={confirmButtonFunc}
        />
      }
      modal
      open={showDialog}
    >
      <div>
        {topText}
        {
          problemFiles.map((file, index) => {
            return (
              <div key={index} style={{ textIndent: '20px' }}>
                <FontIcon
                  className="tc-icon-fiber_manual_record2"
                  style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '8px', marginRight: '5px', verticalAlign: 'middle' }}
                />
                {file.name} - {Math.round(file.size / 1000)}KB
              </div>
            );
          })
        }
        {subtext}
      </div>
    </Dialog>
  );
};

FileError.propTypes = {
  showDialog: PropTypes.bool,
  title: PropTypes.string,
  confirmButtonFunc: PropTypes.func,
  topText: PropTypes.object,
  problemFiles: PropTypes.array,
  subtext: PropTypes.object,
};

export default FileError;



// WEBPACK FOOTER //
// ./src/app/components/extra/dropzone-with-preview/file-error.jsx